import React from 'react';
import { FormControl, Input, Text, VStack } from 'components/ui';
import Select from 'react-select';
import { GENDERS } from '../../../constants/misc';

// by specs, we allow one of the first three values in the genders array
const genderOptions = GENDERS.slice(0, 3).map((g) => ({ label: g, value: g }));

const fieldSelectStyles = {
  container: (base) => ({
    ...base,
    width: '100%',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  // Fields inside the subcard sit on white, since the panel itself is tinted.
  control: (base) => ({
    ...base,
    width: '100%',
    height: 48,
    borderRadius: '8px',
    backgroundColor: '#fff',
    borderColor: 'transparent',
    boxShadow: 'none',
  }),
};

type Props = {
  memberId: string;
  dob: string;
  gender: string;
  firstName: string;
  lastName: string;
  onPlanHolderInfoChange: ({
    memberId,
    dob,
    gender,
    firstName,
    lastName,
  }: {
    memberId: string;
    dob: string;
    gender: string;
    firstName: string;
    lastName: string;
  }) => void;
};

export const PlanHolderInfo = ({
  memberId,
  dob,
  gender,
  firstName,
  lastName,
  onPlanHolderInfoChange,
}: Props) => {
  return (
    <VStack
      alignItems={'stretch'}
      bg={'feather.100'}
      borderColor={'#DBE8EC'}
      borderWidth={1}
      gap={'16px'}
      p={'18px'}
      rounded={'row'}
      w={'100%'}
    >
      <Text
        color={'secondary.500'}
        fontSize={'15px'}
        fontWeight={700}
        w={'100%'}
      >
        Plan Holder’s Information
      </Text>

      <FormControl>
        <FormControl.Label>
          Member ID (exactly as appears on card)
        </FormControl.Label>
        <Input
          bg={'white'}
          maxWidth={'100%'}
          type="text"
          value={memberId ?? ''}
          onChange={(e) => {
            onPlanHolderInfoChange({
              memberId: e.target.value,
              dob,
              gender,
              firstName,
              lastName,
            });
          }}
        />
      </FormControl>

      <FormControl>
        <FormControl.Label>
          First Name (exactly as appears on card)
        </FormControl.Label>
        <Input
          bg={'white'}
          maxWidth={'100%'}
          type="text"
          value={firstName ?? ''}
          onChange={(e) => {
            onPlanHolderInfoChange({
              memberId,
              dob,
              gender,
              firstName: e.target.value,
              lastName,
            });
          }}
        />
      </FormControl>

      <FormControl>
        <FormControl.Label>
          Last Name (exactly as appears on card)
        </FormControl.Label>
        <Input
          bg={'white'}
          maxWidth={'100%'}
          type="text"
          value={lastName ?? ''}
          onChange={(e) => {
            onPlanHolderInfoChange({
              memberId,
              dob,
              gender,
              firstName,
              lastName: e.target.value,
            });
          }}
        />
      </FormControl>

      <FormControl>
        <FormControl.Label>Date of birth (YYYY-MM-DD)</FormControl.Label>
        <Input
          bg={'white'}
          maxWidth={'100%'}
          type="text"
          value={dob ?? ''}
          onChange={(e) => {
            onPlanHolderInfoChange({
              memberId,
              dob: e.target.value,
              gender,
              firstName,
              lastName,
            });
          }}
        />
      </FormControl>

      <FormControl>
        <FormControl.Label>Gender (on insurance card)</FormControl.Label>
        <Select
          components={{ IndicatorSeparator: () => null }}
          styles={fieldSelectStyles}
          placeholder={null}
          value={genderOptions.find((g) => g.value === gender)}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          options={genderOptions}
          onChange={(selection) => {
            onPlanHolderInfoChange({
              memberId,
              dob,
              gender: selection?.value ?? genderOptions[0].value,
              firstName,
              lastName,
            });
          }}
        />
      </FormControl>
    </VStack>
  );
};
